import { PropsWithChildren } from "react";

import { HTMLMotionProps, Variants } from "@enkor/framer-motion";

import { getColorButtonAnimation } from "@domains/common/utils/animationHelper";
import { getOpacityColor, grayScale, green } from "@enkor/design/colors";

import * as S from "./NoticeDialog.style";

const sheetVariants: Variants = {
  hidden: { x: "-50%", y: "-50%", scale: 1.2, opacity: 0 },
  visible: {
    x: "-50%",
    y: "-50%",
    scale: 1,
    opacity: 1,
    transition: { duration: 0.4, ease: [0.05, 0.7, 0.1, 1.0] },
  },
  exit: {
    x: "-50%",
    y: "-50%",
    scale: 1.2,
    opacity: 0,
    transition: { duration: 0.2, ease: [0.3, 0.0, 0.8, 0.15] },
  },
};

type DialogButtonProps = {
  text?: string;
  textColor?: string;
  bgColor?: string;
  hoverColor?: string;
  tapColor?: string;
} & HTMLMotionProps<"button">;

interface NoticeDialogProps {
  modal: {
    title: string;
    description?: string;
  };
  confirmButton: DialogButtonProps;
  cancelButton?: DialogButtonProps;
}

const NoticeDialog = ({
  modal,
  confirmButton,
  cancelButton,
  children,
}: PropsWithChildren<NoticeDialogProps>) => {
  return (
    <S.Container
      variants={sheetVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
    >
      <S.ModalHeader name="h5">{modal.title}</S.ModalHeader>
      {modal?.description && (
        <S.ModalContent name="m">{modal.description}</S.ModalContent>
      )}

      {children && <>{children}</>}

      <S.ButtonWrapper>
        {cancelButton && (
          <S.CancelButton
            {...getColorButtonAnimation({
              hoverColor:
                confirmButton?.hoverColor ||
                getOpacityColor(grayScale.white, 0.15),
              tapColor:
                confirmButton?.tapColor ||
                getOpacityColor(grayScale.white, 0.3),
            })}
            {...cancelButton}
            $textColor={cancelButton?.textColor}
            $bgColor={cancelButton?.bgColor}
            type="button"
          >
            {cancelButton.text || "Close"}
          </S.CancelButton>
        )}

        <S.ConfirmButton
          {...getColorButtonAnimation({
            hoverColor:
              confirmButton?.hoverColor ||
              getOpacityColor(grayScale.white, 0.15),
            tapColor:
              confirmButton?.tapColor || getOpacityColor(grayScale.white, 0.3),
          })}
          {...confirmButton}
          $textColor={confirmButton?.textColor || green.main}
          $bgColor={confirmButton?.bgColor}
          type="button"
        >
          {confirmButton?.text || "Confirm"}
        </S.ConfirmButton>
      </S.ButtonWrapper>
    </S.Container>
  );
};

export default NoticeDialog;
